import { useContext, useEffect, useState } from 'react'
import { EmblaCarouselType } from 'embla-carousel'
import { useBrowser } from '@s4l/utils/hooks/useBrowser'
import { CarouselContext, CarouselContextType, DirectionKind } from '..'

interface IUseNavigationProps {
  startIndex: number
  emblaApi?: EmblaCarouselType
}

export const useNavigation = ({ startIndex, emblaApi }: IUseNavigationProps) => {
  const { device } = useBrowser()
  const { itemsPerPage, onNavigation, totalItems } = useContext<CarouselContextType>(CarouselContext) // prettier-ignore
  const itemsPerPageByDevice = { mobile: itemsPerPage[0], tablet: itemsPerPage[1], desktop: itemsPerPage[2]} // prettier-ignore

  const numberOfPages = Math.ceil(totalItems / Math.floor(itemsPerPageByDevice[device]))

  const startPage = startIndex + 1

  const [currentPage, setCurrentPage] = useState(startPage)

  useEffect(() => {
    const updateCurentPageOnScroll = () => {
      const selectedIndex = emblaApi?.selectedScrollSnap() ?? 0
      if (selectedIndex !== currentPage - 1) {
        setCurrentPage(selectedIndex + 1)
      }
    }

    if (emblaApi) {
      emblaApi?.on('scroll', updateCurentPageOnScroll)
    }
    return () => {
      emblaApi?.off('scroll', updateCurentPageOnScroll)
    }
  }, [emblaApi, currentPage])

  useEffect(() => {
    if (onNavigation) {
      onNavigation((direction: DirectionKind) => {
        setCurrentPage(prev => (direction === 'next' ? prev + 1 : prev - 1))
      })
    }
  }, [onNavigation])

  return {
    currentPage,
    numberOfPages,
    itemsPerPageByDevice,
  }
}
